export const useCaseData = [
  {
    useCases: [
      {
        useCase: "General marketing",
      },
      {
        useCase: "Send birthday Rewards",
      },
      {
        useCase: "Promotional marketing",
      },
      {
        useCase: "Keyword opt-ins",
      },
    ],
  },
  {
    useCases: [
      {
        useCase: "Staff announcements",
      },
      {
        useCase: "Deliver emergency alerts",
      },
      {
        useCase: "Instant lead notifications",
      },
      {
        useCase: "Solicit reviews",
      },
    ],
  },
  {
    useCases: [
      {
        useCase: "Schedule changes",
      },
      {
        useCase: "Customer feedback",
      },
      {
        useCase: "Lead nurturing",
      },
    ],
  },
]

export const industryData = [
  {
    useCases: [
      {
        useCase: "Restaurants",
      },
      {
        useCase: "Marketing agencies",
      },
      {
        useCase: "Independent sales",
      },
      {
        useCase: "Real estate",
      },
    ],
  },
  {
    useCases: [
      {
        useCase: "Retail stores",
      },
      {
        useCase: "Sports & fitness",
      },
      {
        useCase: "Property management",
      },
      {
        useCase: "Financial services",
      },
    ],
  },
  {
    useCases: [
      {
        useCase: "Seminars & events",
      },
      {
        useCase: "Consultants",
      },
      {
        useCase: "Medical practices",
      },
      {
        useCase: "Contractors",
      },
    ],
  },
]
